import { NgModule } from '@angular/core';

import { ModalService } from './modal.service';
import { ModalCreationService } from './modal-creation.service';

@NgModule({
  providers: [
    ModalService,
    ModalCreationService,
  ],
})
export class ModalModule { }
